<template>
  <div class="fat-drawer" :class="{ 'is-open': isOpen }">
    <div class="fat-drawer__content" :class="{ 'is-open': isOpen }">
      <button @click="toggleDrawer()" class="fixed z-50 top-6 right-[4vw] md:right-8">
        <div class="flex items-center gap-2 px-2 py-1 bg-black/60 rounded-md opacity-80 transition-all duration-300 md:hover:opacity-100">
          <span class="text-sm text-white">{{ $t('shared.close') }}</span>
        </div>
      </button>
      <div class="fat-drawer__scrollable">
        <div class="py-6 sticky z-20 top-0 bg-white">
          <p class="font-heading font-medium text-2xl md:text-3xl lg:text-4xl">{{ $t('fat.filter.heading', fat.tagIds.length) }}</p>
        </div>
        <FatFilters class="relative z-10" />
        <div class="py-6 sticky z-20 bottom-0 bg-white" v-if="fat.tagIds?.length">
          <button class="button-coral-outline w-full" @click="resetTags">
            <div class="flex items-center gap-2 justify-center">
              <AtomIcon name="circle-xmark" class="text-sm" />
              <span class="text-sm" v-html="$t('fat.filters.clear', { count: fat.tagIds?.length })" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="fat-drawer__backdrop" :class="{ 'is-open': isOpen }" @click="toggleDrawer()"></div>
  </div>
</template>

<script setup>
const app = useAppStore()
const fat = useFatStore()
const { isOpen, toggleDrawer } = useFatDrawer()

// Reset tags and close drawer
const resetTags = () => {
  console.log('resetTags')
  fat.resetTags()
  toggleDrawer()
}
 
// Watch route query to toggle app scroll lock
watch(() => isOpen.value, () => {
  app.lockScroll = isOpen.value
})
</script>

<style lang="scss" scoped>
.fat-drawer {
  @apply fixed z-50 inset-0 opacity-0 pointer-events-none transition-all duration-300 delay-300;

  &.is-open {
    @apply opacity-100 pointer-events-auto delay-0;
    // @apply lg:hidden;
  }

  &__content {
    @apply bg-white;
    @apply w-full max-w-md;
    @apply fixed z-20 top-0 right-0 bottom-0;
    @apply translate-x-full transition-all duration-300;

    &.is-open {
      @apply translate-x-0;
    }
  }

  &__scrollable {
    @apply px-[4vw] md:px-8;
    @apply flex flex-col justify-start h-full;
    @apply overflow-y-scroll;
    -webkit-overflow-scrolling: touch;
  }

  &__backdrop {
    @apply fixed z-10 inset-0 backdrop-blur-sm bg-black/0 transition-all duration-300;

    &.is-open {
      @apply bg-black/40;
    }
  }
}
</style>